import { AccordionSummary, Box, styled, Typography } from '@mui/material';

export const ScheduleComponentSidebarWrapper = styled(Box)(
  ({ theme }) => `
  position: relative;
  width: 100%;
  height: 100%;
  border-right: 1px solid ${theme.palette.divider};
  overflow-y: auto;
`,
);

export const SidebarHeader = styled(Typography)`
  display: flex;
  align-items: center;
  height: 60px;
  padding-left: 20px;
`;

export const GeneralDetailsContainer = styled(Box)`
  padding: 8px 16px;
`;

export const GeneralDetailsAccordionSummary = styled(AccordionSummary)(
  ({ theme }) => `
borderBottom: 1px solid ${theme.palette.divider};
`,
);
